/* eslint-disable */
import React, { useRef, useState } from 'react';
import Downshift from 'downshift';
import classNames from 'classnames';
import injectSheet from 'react-jss';
import Loader from '../../components/loader';
import { options } from '../../components/loader/options';
import { getDefaultOptions } from '../../utils/uiOverrides';
import { CollegePills } from 'Containers/collegePills';

const styleSheet = (theme: any) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '8px',
    },
    '*::-webkit-scrollbar-track': {
      borderRadius: '3px',
      backgroundColor: '#f5f7ff',
    },
    '*::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#b7c1e1',
    },
  },
  input: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:-ms-input-placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:focus': {
      border: 'solid 2px #085fe5',
    },
    outline: 0,
    width: '100%',
    height: '72px',
    objectFit: 'contain',
    borderRadius: '6px',
    border: 'solid 2px #b7c1e1',
    boxSizing: 'border-box',
    padding: '24px 27px',
    fontSize: '24px',
    color: '#4f5b84',
  },
  label: {
    ...theme.label,
    display: 'block',
    textAlign: 'left',
    paddingLeft: '9px',
    marginBottom: '14px',
    color: '#223762',
    fontWeight: '800',
  },
  error: theme.button.error,
  wrapper: {
    flex: 1,
    position: 'relative',
  },
  optionsHolder: {
    position: 'absolute',
    width: '100%',
    zIndex: 1,
  },
  hideOnMobile: {},
  dropDownHolder: {
    width: '100%',
    zIndex: 1,
    position: 'absolute',
  },
  dropDown: {
    border: 'solid 2px #b7c1e1',
    borderTop: 'none',
    backgroundColor: '#fff',
    marginTop: '-12px',
    paddingTop: '0px',
    borderBottomRightRadius: '6px',
    borderBottomLeftRadius: '6px',
    maxHeight: '208px',
    overflowY: 'scroll',
    zIndex: 2,
    position: 'relative',
    minHeight: '10px',
  },
  dropDownItem: {
    cursor: 'pointer',
    padding: '16px 32px',
    fontSize: '24px',
    textAlign: 'left',
    fontFamily: 'CircularStd, sans-serif',
    color: '#4f5b84',
    borderRadius: '6px',
  },
  dropDownSubItem: {
    color: '#B9C1DE',
    fontSize: '18px',
    display: 'block',
  },
  select: {
    cursor: 'pointer',
    outline: 'none',
    position: 'absolute',
    width: '60px',
    height: '72px',
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    right: '0 !important',
    left: 'inherit !important',
    '& .icon': {
      transformOrigin: '50% 50%',
      width: '30px',
      '@media (max-width: 900px)': {
        width: '25px',
      },
    },
  },
  '@media (max-width: 900px)': {
    input: {
      height: '64px',
      fontSize: '20px',
    },
    select: {
      height: '64px',
    },
    label: {
      fontSize: '10px',
    },
    dropDownItem: {
      fontSize: '20px',
    },
    hideOnMobile: {
      display: 'none',
    },
    loaderContainer: {
      '& div#loader': {
        marginTop: '11px !important',
      },
    },
  },
  loaderContainer: {
    width: '100%',
    position: 'absolute',
    bottom: '0',
    height: '72px',
    '& div#loader': {
      width: '60px',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      marginTop: '9px',
      right: '23px',
    },
  },
});

interface DefaultValue {
  label: string;
  value: string;
}

interface Props {
  classes?: any;
  items: any;
  label: string;
  error?: boolean;
  placeholder?: string;
  name: string;
  allowDropdown: boolean;
  onChange?: (e: object) => void;
  onType?: (val: string) => void;
  defaultValue?: any;
  loading?: boolean;
  useDefaultValues?: boolean;
  isMultiSelect?: boolean;
  hideInputBox?: boolean;
}

const AutoComplete: React.FC<Props> = props => {
  const mapValueToSelectedItem =
    props.items.find(
      (item: { value: string }) => item.value === props.defaultValue
    ) || null;

  const [inputValue, setInputValue] = useState('');
  let labels: any = [];
  labels = props.items;

  const mapOptions = (
    labelsArray: any,
    inputValue: string,
    includeAllOnEmpty: boolean
  ) => {
    if (props.loading || !inputValue.length) {
      if (includeAllOnEmpty) return labelsArray;
      return [];
    }

    if (!props.useDefaultValues) {
      return labelsArray;
    } else {
      return getDefaultOptions(props.name);
    }
  };

  const onChange = (selected: string) => {
    var response;

    // Need to handle
    var labelSources = labels.length ? labels : getDefaultOptions(props.name);
    let findSelected = labelSources.find(
      (item: any) => item['label'] === selected
    );
    response = {
      target: {
        value: findSelected!['value'],
        fieldId: props.name,
        label: findSelected!['label'],
      },
    };

    props.onChange ? props.onChange(response) : null;
  };

  const onType = (inputValue: string) => {
    props.onType ? props.onType(inputValue) : null;
  };
  const inputRef = useRef();

  return (
    <Downshift
      inputValue={inputValue}
      onChange={selected => {
        onChange(selected);
        if (!props.isMultiSelect && inputRef && inputRef.current) {
          //@ts-ignore
          inputRef.current.blur();
        }
        if (props.isMultiSelect) {
          setInputValue('');
        }
      }}
      onStateChange={() => {
        onType(inputValue);
      }}
      onInputValueChange={(input: string) => {
        if (props.isMultiSelect && document.activeElement !== inputRef.current)
          setInputValue('');
        else setInputValue(input);
      }}
      initialSelectedItem={props.defaultValue ? props.defaultValue.label : null}
    >
      {({
        getInputProps,
        getItemProps,
        getLabelProps,
        getToggleButtonProps,
        isOpen,
        highlightedIndex,
        selectedItem,
      }) => (
        <div className={props.classes.wrapper}>
          <label
            className={classNames(props.classes.label, {
              [props.classes.hideOnMobile]: props.label.length == 1,
            })}
            {...getLabelProps()}
          >
            {props.label}
          </label>
          {props.isMultiSelect && <CollegePills ref={inputRef} />}
          {!props.hideInputBox && props.allowDropdown && (
            <button
              name={props.name}
              data-type={'list'}
              style={{ color: inputValue ? '#4f5b84' : '#b7c1e1' }}
              className={classNames(props.classes.select, {
                [props.classes.error]: props.error,
              })}
              {...getToggleButtonProps()}
            >
              <img
                style={{
                  transform: isOpen ? 'rotate(180deg)' : '',
                }}
                className="icon"
                src="images/UI/downarrow.svg"
              />
            </button>
          )}
          {!props.hideInputBox && (
            <input
              ref={inputRef}
              name={props.name}
              aria-label={props.name}
              data-type={'list'}
              placeholder={mapValueToSelectedItem?.label || props.placeholder}
              className={classNames(props.classes.input, {
                [props.classes.error]: props.error,
              })}
              {...getInputProps()}
            />
          )}
          {!props.hideInputBox && isOpen ? (
            <div className={classNames(props.classes.dropDownHolder)}>
              <div
                className={classNames(props.classes.dropDown, {
                  [props.classes.error]: props.error,
                })}
              >
                {mapOptions(labels, inputValue, props.allowDropdown)
                  // @ts-ignore
                  .map((item, index) => {
                    const labels = item['label'].match(/[^()]+/g);
                    return (
                      <div
                        className={props.classes.dropDownItem}
                        {...getItemProps({
                          key: index,
                          item: item['label'],
                          style: {
                            backgroundColor:
                              highlightedIndex === index ? '#f5f7ff' : 'white',
                            fontWeight:
                              selectedItem === item ? 'bold' : 'normal',
                          },
                        })}
                      >
                        {labels[0]}
                        {labels[1] && (
                          <div className={props.classes.dropDownSubItem}>
                            {labels[1]}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          ) : null}
          {props.loading && (
            <div
              className={props.classes.loaderContainer}
              id={'loading-container'}
            >
              <Loader
                isVisible={props.loading || isOpen}
                animationData={options.loading1}
              />
            </div>
          )}
        </div>
      )}
    </Downshift>
  );
};

AutoComplete.defaultProps = {
  useDefaultValues: false,
};

export default injectSheet(styleSheet)(AutoComplete);
